"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var mutable_observer_1 = require("./mutable-observer");
var use_rx_1 = require("./use-rx");
/**
 * `useRxEffect`
 *
 * Use this hook when you need to react on observable changes.
 *
 * Example:
 * useRxEffect(name$, (newName) => console.log(newName))
 *
 * This code will print a name in the console on every emit of the observable name$.
 *
 * @param observable$
 * @param next
 */
function useRxEffect(observable$, next) {
    var observer = react_1.useMemo(function () { return new mutable_observer_1.MutableObserver(); }, [observable$]);
    observer.setNext(next);
    use_rx_1.useRx(observable$, observer);
}
exports.useRxEffect = useRxEffect;
//# sourceMappingURL=use-rx-effect.js.map